import React from 'react';
import {observer} from 'mobx-react';
import {withState} from 'shared/core';
import RequestDetailsState from '../state/RequestDetailsState';
import {Display} from 'shared/components';
import _ from 'lodash';
import TimeOffRequestDetails from './TimeOffRequestDetails';
import PendingRequestDetailsWithState from '../../pending_requests/components/PendingRequestDetailsWithState';
import {FormattedMessage} from 'react-intl';
import WorkTimeImage from 'img/hr-upgrade/work-time@2x.png';

const RequestDetails = observer(({uiState}) => {
  const {request, backButtonDetails, error} = uiState;
  const {backTitle} = backButtonDetails;

  if (error) {
    return (
      <div className='Container center pt4'>
        <img src={WorkTimeImage} alt='Nothing to action' className='mb3'/>
        <p className='mb1 h3'>
          <FormattedMessage id="time_off.requests.You're all set!"/>
        </p>
        <div className='jumbo'>
          <FormattedMessage id='time_off.requests.This request has already been actioned.'/>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Display
        title={_.get(request, 'employee.name')}
        backTitle={backTitle}
        onBackClick={() => uiState.goBack()}
      />
      {request.actionable ?
        <PendingRequestDetailsWithState request={request} goBack={(alert) => uiState.goBack(alert)} /> :
        <TimeOffRequestDetails request={request} />
      }
    </div>
  );
});

export default withState(RequestDetails, RequestDetailsState);
